import React from 'react';
import { LocalString, Plural, Money } from 'translate-react';
import { togglePanel } from '../actions';

let ObjectContent = (props, contect) => {
	return <div>ObjectContent</div>;
};

ObjectContent.contextTypes = { store: React.PropTypes.object };

export default ObjectContent;



/** WEBPACK FOOTER **
 ** ../ibe/desktop/ObjectContent.js
 **/